<template>
  <div>
    <section class="wrapper mt-32 sm:mt-40">
      <h1 class="text-center font-serif">Wir über uns</h1>
    </section>
    <!-- <ImageGallery
      class="mt-8 px-4 sm:px-0 max-w-3xl mx-auto"
      :single="true"
      :image="aboutUsImage"
    /> -->
    <section role="main" class="max-w-3xl px-4 mx-auto mt-6 sm:mt-12">
      <img
        src="../assets/img/about/vermieter.jpg"
        class="w-full lazyload my-6 sm:px-0"
      />
      <p class="font-bold text-xl">
        Hallo! Schön, dass Sie unsere Homepage besuchen.
      </p>
      <p class="mt-2">
        Wir - Agnes und Hanspeter mit unseren Kindern Julian, Benedikt und
        Johanna haben unser zu Hause auf der ruhigen und sonnigen Südseite
        oberhalb des Aiterner Tals auf 720 m ü.M.
      </p>
      <Quote
        class="my-6 sm:my-10"
        :text="quotes.first.text"
        :author="quotes.first.author"
      />
      <!-- <span class="block mx-auto max-w-3xl border-l-2 py-2 pl-4 my-8">
        <q class="font-serif text-2xl"
          >Die beiden schönsten Dinge sind die Heimat, aus der wir stammen und
          die Heimat, nach der wir wandern.</q
        >
        <p class="mt-4 italic">- Johann Heinrich Jung-Stilling</p>
      </span> -->
      <p class="mt-2">
        Gemütlichkeit, Komfort und Ihre individuellen Bedürfnisse stehen im
        Mittelpunkt unserer Bemühungen, Ihre Ferientage in unserem Hause zu
        "SONNENTAGEN" zu machen.
      </p>
      <p class="mt-2">
        Lernen Sie die Gastfreundschaft einer „Schwarzwälder“ - Familie kennen.
        Wir freuen uns auf Ihren Besuch!
      </p>
    </section>
    <section
      class="
        wrapper
        text-center
        mt-12
        text-red-500
        hover:text-red-600
        ease-in-out
        duration-150
        transition-colors
      "
    >
      <router-link class="p-2 border-b text-lg font-bold" to="/kontakt"
        >Kontakt aufnehmen</router-link
      >
    </section>
    <!-- <section class="bg-teal-500 mt-24">
      <div class="wrapper py-24">
        <PersonCard
          name="Agnes & Hanspeter Asal"
          label="Wir freuen uns auf Sie"
          mail="info@haus-morgensonne.com"
          telefon="076737043"
          class="bg-white"
        />
      </div>
    </section> -->
  </div>
</template>

<script>
import ImageGallery from '../components/ImageGallery.vue'
import Quote from '../components/Quote.vue'

export default {
  name: 'About',
  components: { ImageGallery, Quote },
  data() {
    return {
      name: 'This is the Imagegallery component',
      quotes: {
        first: {
          text: 'Die beiden schönsten Dinge sind die Heimat, aus der wir stammen und die Heimat, nach der wir wandern.',
          author: 'Johann Heinrich Jung-Stilling',
        },
      },
      aboutUsImage: {
        src: 'img/about/vermieter.jpg',
        w: 1600,
        h: 1067,
        thumbnail: 'img/about/thumb/vermieter.jpeg',
        description: '© Achim Keller',
      },
    }
  },
}
</script>
